import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {parseDate} from "@internationalized/date";
import {Button, DateRangePicker, Table} from "aria";
import formatters from "helpers/formatters.jsx";
import moment from "moment";
import {useEffect, useState} from "react";
import MainChart from "./mainChart.tsx";

export default function Dashboard(props) {
  const appDataStore = useAppDataStore()
  const [data, setData] = useState()
  const [tableCols, setTableCols] = useState([])
  const [tableRows, setTableRows] = useState([])
  const [totales, setTotales] = useState({})

  const [dateFilter, setDateFilter] = useState({
    start: parseDate(moment().startOf('year').format('YYYY-MM-DD')),
    end: parseDate(moment().endOf('day').format('YYYY-MM-DD')),
  })

  const onChangeDateFilter = ({start, end}) => {
    setDateFilter({start, end})
  }

  const fetchData = async (force = false) => {
    setData(null)
    const {start, end} = dateFilter
    const res = await appDataStore.post('/app/dashboard', {
      startDate: moment(start.toDate()).startOf('day'),
      endDate: moment(end.toDate()).endOf('day'),
      force
    })
    setData(res.data)
  }

  useEffect(() => {

    if (data) {

      const tableData = []

      for (const accountData of data) {
        for (const periodData of accountData.data) {
          tableData.push({account: accountData.label, period: periodData.primary, amount: periodData.secondary})
        }
      }
      const cols = tableData.reduce((acc, item) => {
        if (acc.indexOf(item.period) < 0) acc.push(item.period)
        return acc
      }, [])

      const rows = tableData.reduce((acc, item) => {
        let row = acc.find(i => item.account === i.account)
        if (!row) {
          row = {account: item.account, periods: []}
          acc.push(row)
        }
        row.periods.push({period: item.period, amount: item.amount})
        return acc
      }, [])

      const totales = tableData.reduce((acc, item) => {
        if (!acc[item.period]) acc[item.period] = 0
        if (!acc[item.account]) acc[item.account] = 0
        acc[item.period] += item.amount
        acc[item.account] += item.amount
        return acc
      }, {})
      setTableCols(cols)
      setTableRows(rows)
      setTotales(totales)
    } else {
      setTableCols([])
      setTableRows([])
    }
  }, [data]);

  useEffect(() => {
    setData(null)
    fetchData()
  }, [dateFilter]);


  return (
    <>
      <div className="p-2 max-w-7xl mx-auto text-black fill-gray-800">
        <div>
          <div className={'inline-block'}><DateRangePicker value={dateFilter} onChange={onChangeDateFilter}/>
          </div>
          <div className={'inline-block ml-3'}><Button onPress={() => fetchData(true)} style={{height: 31}}>Actualizar
            Datos</Button></div>
        </div>
        {data && data.length >0 ? <>
          <MainChart data={data}/>
          <div className="flex flex-col mt-10 border rounded-md">
            <div className="-m-1.5 overflow-x-auto">
              <div className="p-1.5 min-w-full inline-block align-middle">
                <div className="overflow-hidden">
                  <table className={'min-w-full divide-y divide-gray-200 dark:divide-neutral-700'}>
                    <thead>
                    <tr>
                      <th
                        className={'px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase dark:text-neutral-500'}>Cuenta/Periodo
                      </th>
                      {tableCols.map((col) => (<th
                        className={'px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase dark:text-neutral-500'}>{col}</th>))}
                      <th
                        className={'px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase dark:text-neutral-500'}>Total
                        Cuenta
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    {tableRows.map((row) => {
                        const {periods, account} = row
                        return (
                          <tr className={'odd:bg-white even:bg-gray-100'}>
                            <td className={'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800'}>{account}</td>
                            {tableCols.map((column) => {
                              const period = periods.find(({period}) => period === column)
                              return <td
                                className={'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800'}>{formatters.cash(period ? period.amount : 0)}</td>
                            })}
                            <td
                              className={'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800'}>{formatters.cash(totales[account])}</td>
                          </tr>
                        )
                      }
                    )}
                    </tbody>
                    <tfoot>
                    <tr>
                      <td>Total Periodo</td>
                      {tableCols.map((col) => (<th>{formatters.cash(totales[col])}</th>))}
                      <td></td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </> : <div className={'pt-10 text-center'}>Cargando...</div>}
      </div>
    </>
  )
}